import { NamedRoutes } from '@/app/core/services/named-router';

import { authGuard, guestGuard, profileResolverGuard } from '@/app/core/guards';

export const AppRoutes: NamedRoutes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadChildren: () => import('./auth/auth.routes').then((mod) => mod.AuthRoutes),
  },
  {
    path: 'subscription/:status',
    name: 'subscription-status',
    loadComponent: () =>
      import('@/app/pages/subscription-status/subscription-status.component').then(
        (mod) => mod.SubscriptionStatusComponent,
      ),
  },
  {
    path: '',
    canMatch: [authGuard, profileResolverGuard],
    loadComponent: () =>
      import('@/app/core/layouts/dashboard-layout/dashboard-layout.component').then(
        (mod) => mod.DashboardLayoutComponent,
      ),
    loadChildren: () => import('./dashboard/dashboard.routes').then((mod) => mod.DashboardRoutes),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
